import React, { FC, useState, ReactNode } from "react";
import { MinusIconSmall, PlusIconSmall } from "../../../../icons";

export interface IFilterMoreLessButtonProps {
  title: string;
  type: "button" | "submit" | "reset";
  children?: ReactNode;
  onClick?(): void;
}

export const FilterMoreLessButton: FC<IFilterMoreLessButtonProps> = ({
  title,
  type,
  onClick,
  children,
}) => {
  const [buttonClicked, setButtonClicked] = useState<boolean>(false);

  const onButtonClick = () => setButtonClicked(!buttonClicked);

  return (
    <div onClick={onButtonClick}>
      <button
        onClick={onClick}
        className="filter-top-more"
        // eslint-disable-next-line react/button-has-type
        type={type}
        id={title}
        aria-expanded="false"
      >
        {title}
        <div className="icon-container dropdown-toggle__icon">
          {buttonClicked ? <MinusIconSmall /> : <PlusIconSmall />}
        </div>
      </button>
      {children}
    </div>
  );
};

export default FilterMoreLessButton;
